import { LinkTab, NotFound } from "@dgs/core";
import { FC } from "react";
import { Navigate, Route, Routes } from "react-router";
import styled from "styled-components";
import { DefaultContentLayout } from "../shared/Layout";
import { AccessDeniedPage } from "../shared/ui/AccessDeniedPage";
import { useGlobalTenants } from "../tenants/global/GlobalTenantProvider";
import { ArchivedContactDetails } from "./ArchivedContactDetails";
import { ArchivedContactList } from "./ArchivedContactList";
import { ContactDetailPages, ContactDetailsNavigation } from "./ContactDetailPages";
import { ContactList } from "./ContactList";
import { RedirectToContact } from "./RedirectToContact";

export const StyledLinkTab = styled(LinkTab)`
	background-color: #fff;
`;

export const ContactPage: FC = () => {
	const { selected } = useGlobalTenants();

	if (!selected.tenant) {
		return <AccessDeniedPage />;
	}

	return (
		<Routes>
			<Route index element={<Navigate replace to="active" />} />
			<Route path="active">
				<Route
					index
					element={
						<DefaultContentLayout>
							<ContactList />
						</DefaultContentLayout>
					}
				/>
				<Route path=":id" element={<ContactDetailsNavigation />}>
					<Route path="*" index element={<ContactDetailPages />} />
				</Route>
			</Route>
			<Route path="archived">
				<Route
					index
					element={
						<DefaultContentLayout>
							<ArchivedContactList />
						</DefaultContentLayout>
					}
				/>
				<Route path=":id" element={<ContactDetailsNavigation />}>
					<Route path="*" index element={<ArchivedContactDetails />} />
				</Route>
			</Route>
			<Route
				path="/filter/*"
				element={
					<DefaultContentLayout>
						<ContactList />
					</DefaultContentLayout>
				}
			/>
			<Route path=":id" element={<RedirectToContact />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
